import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';

import type { OrderStateMap } from './order.model';
import { initialOrderMap } from './order.model';

export function orderReducer(state: OrderStateMap = initialOrderMap, action: Action): OrderStateMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_CP_ORDER_PLACEMENT_REQUESTED':
      return addOrReplaceKey(state, action.tabId, { status: 'PENDING' });
    case 'SECONDARY_MARKET_CP_ORDER_PLACEMENT_RECEIVED':
      return patchKey(state, action.tabId, _ => ({
        status: 'DONE' as const,
        id: action.id,
        cobDate: action.cobDate,
        settlementDate: action.settlementDate,
        tradeDate: action.tradeDate,
        valuationDate: action.valuationDate,
        execTime: action.execTime,
        validations: action.validations,
      }));
    case 'SECONDARY_MARKET_CP_ORDER_PLACEMENT_FAILED':
      return addOrReplaceKey(state, action.tabId, {
        status: 'REJECTED',
        isTimeout: action.isTimeout,
        errorMessage: action.errorMessage,
        timeout: action.timeout,
      });
    case 'SECONDARY_MARKET_CP_ORDER_CLOSE':
      return removeKey(state, action.tabId);
    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);
    case 'WORKSPACE_TABS_ALL_REMOVED':
      if (action.workspace === 'secondaryMarketQuotes') {
        return initialOrderMap;
      } else {
        return state;
      }
    default:
      return state;
  }
}
